/* import __COLOCATED_TEMPLATE__ from './seller-posting-header.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { htmlEntitiesDecode } from 'sh-www/utils/misc';
import { htmlSafe } from '@ember/template';
import { ASSIGNMENT } from 'sh-www/models/assignment';
import clsx from 'clsx';

const CLASS_NAME = 'GLM-c-seller-posting-header';

class SellerPostingHeaderComponent extends Component {
  @service constants;

  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME,
    );
  }

  get className() {
    return CLASS_NAME;
  }

  get brandOrCompanyName() {
    const { brand, buyer } = this.args.assignment;
    return htmlSafe(brand?.displayedName ?? buyer.company.name);
  }

  get assignmentTitle() {
    const { application, assignment } = this.args;

    // urgent version of memorialized title
    if (assignment.isUrgent && application?.applicationDetails?.title) {
      return htmlEntitiesDecode(`[Urgent] ${application.applicationDetails.title}`);
    }

    // determine whether to use memorialized version
    return htmlEntitiesDecode(application?.applicationDetails?.title ?? assignment.titleWithUrgent);
  }

  /** @type {string} */
  get applicationTitle() {
    return htmlEntitiesDecode(this.args.application.title);
  }

  /** @type {boolean} */
  get isCallForPitches() {
    return this.args.assignment.type === ASSIGNMENT.TYPES.PITCH;
  }

  /** @type {number} */
  get applicationsCount() {
    return this.args.assignment.applications.length;
  }
}

export default SellerPostingHeaderComponent;
